import externalLinksMixin from '@/mixins/externalLinks';

export default {
  mixins: [
    externalLinksMixin,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    providerCount() {
      let count = 0;
      if (this.facebookLink) count += 1;
      if (this.googleLink) count += 1;
      if (this.twitterLink) count += 1;
      return count;
    },
    providerColumnClass() {
      // Foundation uses 12-column grid: 1 provider = 12, 2 providers = 6, 3 providers = 4
      const columnWidth = this.providerCount > 0 ? Math.floor(12 / this.providerCount) : 4;
      return `column small-${columnWidth}`;
    },
    availableProvidersText() {
      const providers = [];
      if (this.facebookLink) providers.push('Facebook');
      if (this.googleLink) providers.push('Google');
      if (this.twitterLink) providers.push('X');

      if (providers.length === 0) return '';
      if (providers.length === 1) return providers[0];
      if (providers.length === 2) return `${providers[0]} or ${providers[1]}`;
      return `${providers.slice(0, -1).join(', ')} or ${providers.slice(-1)}`;
    },
  },
  created() {
    this.getExternalLogins({})
      .then((response) => {
        this.links = response.data;
      });
  },
};



// WEBPACK FOOTER //
// ./src/components/forms/socials/socials.js